<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title">
                                    Remover conta de cliente
                                </h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    Tem certeza que deseja remover o cliente
                                    <strong>{{ customer.name }}</strong
                                    >? <br />
                                    <span
                                        >Esta ação não poderá ser
                                        desfeita.</span
                                    >
                                </p>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Para confirmar a remoção, digite abaixo
                                        o texto
                                        <span class="bg-red-lt px-1">{{
                                            customer.name
                                        }}</span
                                        >:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="customerNameConfirmation"
                                        id="confirmationInput"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <a
                                    href="/customers"
                                    class="btn btn"
                                    id="cancelAndBackButton"
                                >
                                    <i class="ti ti-arrow-left"></i>
                                    Cancelar e voltar
                                </a>
                            </div>
                            <div class="col-auto">
                                <a
                                    v-on:click="removeCustomer"
                                    class="btn btn-danger"
                                    id="removeAccountButton"
                                >
                                    <i class="ti ti-trash"></i>
                                    Remover a conta do cliente
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../services/api"
import EventBus from "../services/event-bus"

export default {
    name: "CustomerDeletePage",
    data() {
        return {
            customerNameConfirmation: "",
            customer: {}
        }
    },
    async mounted() {
        var id = this.$route.params.id
        var response = await Api.customers.get(id)
        this.customer = response.data
    },
    methods: {
        async removeCustomer() {
            var id = this.$route.params.id
            try {
                if (this.validate()) {
                    await Api.customers.delete(id)

                    this.$router.push("/customers")

                    EventBus.emit("message", {
                        type: "success",
                        message: "Cliente removido com sucesso!"
                    })
                }
            } catch (error) {
                EventBus.emit("message", {
                    type: "error",
                    message: "Erro ao remover o cliente:" + error
                })
            }
        },
        validate() {
            if (this.customer.name !== this.customerNameConfirmation) {
                EventBus.emit("message", {
                    type: "warning",
                    message:
                        "O nome do cliente não confere com o nome digitado!"
                })

                return false
            }
            return true
        }
    }
}
</script>
